import Vue from 'vue';
import AllEmployersCareersPage from '../components/ats/careers-page/all-employers-careers-page.vue';

const vueInstance = new Vue({
  components: { AllEmployersCareersPage },
});

vueInstance.$mount('.all-employers-careers-page');
